import "./Footer.css";
import { Link, useNavigate } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
  FaWhatsapp,
} from "react-icons/fa";
import logo from "../assets/images/logo.png";
import { AuthContext } from "../context/AuthContext";
import { BACKEND_URL } from "../config"; // apne project ke hisaab se path adjust karein

function Footer() {
  const { setShowAuth, setAuthMode } = useContext(AuthContext);
  const navigate = useNavigate();
  const [openSection, setOpenSection] = useState(null);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api.php?module=category`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setCategories(data.data);
        else setCategories([]);
      })
      .catch((err) => console.log(err));
  }, []);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const openLogin = () => {
    setAuthMode("signin");
    setShowAuth(true);
  };

  const openRegister = () => {
    setAuthMode("signup");
    setShowAuth(true);
  };

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* BRAND */}
        <div className="footer-section brand">
          <Link
            to="/"
            className="footer-logo"
            onClick={() => {
              navigate("/");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <img src={logo} alt="MediCare" className="footer-brand-logo" />
          </Link>

          <p>
            Your trusted online pharmacy
            delivering genuine medicines
            at your doorstep.
          </p>

          <div className="social-icons">
            <Link to="/"><FaFacebookF /></Link>
            <Link to="/"><FaInstagram /></Link>
            <Link to="/"><FaTwitter /></Link>
            <Link to="/"><FaLinkedin /></Link>
            <Link to="/"><FaWhatsapp /></Link>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-section">
          <h3 className="footer-title" onClick={() => toggleSection("quick")}>
            Quick Links
          </h3>

          <ul className={openSection === "quick" ? "footer-list active" : "footer-list"}>
            <li><span onClick={() => handleNavigation("/")}>Home</span></li>
            <li><span onClick={() => handleNavigation("/about")}>About</span></li>
            <li><span onClick={() => handleNavigation("/blog")}>Blog</span></li>
            <li><span onClick={() => handleNavigation("/my-orders")}>My Orders</span></li>
            <li><span onClick={openLogin}>Sign In</span></li>
            <li><span onClick={openRegister}>Sign Up</span></li>
          </ul>
        </div>

        {/* CATEGORIES — sirf top 6 dikhayenge, baaki "View All" ke peeche */}
        <div className="footer-section footer-categories-section">
          <h3 className="footer-title" onClick={() => toggleSection("categories")}>
            Categories
          </h3>

          <div
            className={
              openSection === "categories"
                ? "footer-categories-grid active"
                : "footer-categories-grid"
            }
          >
            {categories.slice(0, 6).map((cat) => (
              <span
                key={cat.id || cat.slug}
                className="footer-cat-link"
                onClick={() => handleNavigation(`/categories/${cat.slug}`)}
              >
                {cat.categoryName}
              </span>
            ))}
          </div>

          <span
            className="footer-view-all"
            onClick={() => handleNavigation("/categories")}
          >
            View All Categories →
          </span>
        </div>

        {/* USER GUIDE */}
        <div className="footer-section">
          <h3 className="footer-title" onClick={() => toggleSection("guide")}>
            User Guide
          </h3>

          <ul className={openSection === "guide" ? "footer-list active" : "footer-list"}>
            <li><span onClick={() => handleNavigation("/indian-pharmacies")}>Indian Pharmacies</span></li>
            <li><span onClick={() => handleNavigation("/protect-yourself")}>Protect Yourself</span></li>
            <li><span onClick={() => handleNavigation("/regulated-medicine")}>Regulated Medicine</span></li>
            <li><span onClick={() => handleNavigation("/returns-exchanges")}>Returns & Exchanges</span></li>
            <li><span onClick={() => handleNavigation("/safe-shopping")}>Safe Shopping</span></li>
            <li><span onClick={() => handleNavigation("/faq")}>FAQ's</span></li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-section">
          <h3 className="footer-title" onClick={() => toggleSection("contact")}>
            Contact
          </h3>

          <ul className={openSection === "contact" ? "footer-list active" : "footer-list"}>
            <li>Email: support@realgenericshop.com</li>
            <li>Phone: +91 98765 43210</li>
            <li>Support: 24/7 Available</li>
            <li>Location: India</li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2026 MediCare. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;